var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"cabinet-blank"},[_c('main',[_c('b-container',{staticClass:"px-3 py-0",attrs:{"fluid":"","id":"content"}},[_c('router-view')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }